import { render, staticRenderFns } from "./SecaoContador.vue?vue&type=template&id=e92a69d0&"
import script from "./SecaoContador.vue?vue&type=script&lang=js&"
export * from "./SecaoContador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports